var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.605,
    height: 34.605,
    viewBox: "0 0 34.605 34.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2230",
    "data-name": "Rectangle 2230",
    width: 34.605,
    height: 34.605,
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10202",
    "data-name": "Group 10202",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10201",
    "data-name": "Group 10201",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27567",
    "data-name": "Path 27567",
    d: "M33.331,0H19.1a3.815,3.815,0,0,0-2.7,1.121L1.119,16.4a3.816,3.816,0,0,0,0,5.4L12.8,33.486a3.816,3.816,0,0,0,5.4,0L33.484,18.2A3.815,3.815,0,0,0,34.6,15.5V1.274A1.274,1.274,0,0,0,33.331,0M32.058,15.5a1.271,1.271,0,0,1-.372.9L16.4,31.687a1.271,1.271,0,0,1-1.81,0L2.918,20.013a1.271,1.271,0,0,1,0-1.81L18.2,2.919a1.271,1.271,0,0,1,.9-.372H32.058Z",
    transform: "translate(0 0)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27568",
    "data-name": "Path 27568",
    d: "M17.32,10.021A3.821,3.821,0,1,0,13.5,6.2a3.822,3.822,0,0,0,3.821,3.821m0-5.094A1.274,1.274,0,1,1,16.046,6.2,1.274,1.274,0,0,1,17.32,4.926",
    transform: "translate(9.424 1.661)",
    fill: "#ffe800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon15);
export default __webpack_public_path__ + "static/media/social_icon15.f6284ded5b6c135564ffb88d149dba00.svg";
export { ForwardRef as ReactComponent };